import React from 'react';
import { Box, Checkbox, Heading, Text } from '@razorpay/blade/components';
import { useFormWithProvider } from 'forms';

import type { AttendanceSettingsFormState } from 'components/Settings/AttendanceAndLeavesSettings/types';

export const AttendanceOptions = () => {
  const { formData, setFieldValue } = useFormWithProvider<AttendanceSettingsFormState>();

  return (
    <Box
      padding="spacing.6"
      borderRadius="medium"
      borderWidth="thin"
      borderColor="surface.border.gray.subtle"
      backgroundColor="surface.background.gray.intense">
      <Heading size="medium">Attendance options</Heading>
      <Text marginTop="spacing.2" size="medium" color="surface.text.gray.muted">
        Control how employees mark attendance and what appears on their payslips.
      </Text>

      <Box marginTop="spacing.6" display="flex" flexDirection="column" gap="spacing.5">
        {formData.hasBiometricDevices && (
          <Checkbox
            isChecked={formData.useWebAttendanceWithBiometric}
            onChange={({ isChecked }) => setFieldValue('useWebAttendanceWithBiometric', isChecked)}
            helpText="Employees can check in and check out from a browser. No mobile app needed.">
            Web attendance
          </Checkbox>
        )}

        <Checkbox
          isChecked={formData.showAttendanceOnPayslip}
          onChange={({ isChecked }) => setFieldValue('showAttendanceOnPayslip', isChecked)}
          helpText="Show present, absent, and leave days as a block on every payslip.">
          Show attendance summary on payslip
        </Checkbox>
      </Box>
    </Box>
  );
};
